import {
  IGetFieldsRequest, IFieldService, injectSort, injectPagination, injectQuery, IFieldEnum, IAutoMapEnumFilter, IAutoMapEnum,
  IServerSideGetRowsParams
} from '@samc/centricity-core';
import { AjaxHelper, getAllPagination, IPaginatedList } from '@samc/common';
import { ICustomServicerImportField } from '../Interfaces';

export class ServicerLoanFieldService implements IFieldService {
  public constructor(private _helper: AjaxHelper) { }

  public async getFieldCategories(): Promise<string[]> {
    return await this._helper.getData('/internalFields/categories');
  }

  public async getFields(req?: IGetFieldsRequest, params?: IServerSideGetRowsParams): Promise<IPaginatedList<ICustomServicerImportField>> {
    const query = getAllPagination();
    if (params !== undefined) {
      injectPagination(query, params);
      injectSort(query, params);
      injectQuery(req, params);
    }
    return await this._helper.postData('/internalFields/search', req, query);
  }

  public async getEnumerations<T extends IFieldEnum>(fieldId: number): Promise<T[]> {
    return await this._helper.getData(`/internalFields/${fieldId}/enums`);
  }
  /**
   * @inheritdoc
   */
  public async getAutoMapEnums(filter: IAutoMapEnumFilter[], abortController?: AbortController): Promise<IAutoMapEnum[]> {
    return await this._helper.postData<IAutoMapEnum[]>('/automap/enums/search', filter, {}, { signal: abortController?.signal });
  }

  /**
   * @inheritdoc
   */
  public async upsertAutoMapEnums(suggestions: IAutoMapEnum[], user: string): Promise<IAutoMapEnum[]> {
    return await this._helper.postData<IAutoMapEnum[]>('/automap/enums', suggestions, { user });
  }
  public async addEnumerations<T extends IFieldEnum>(fieldId: number, createdBy: string, ...enumerations: T[]): Promise<T[]> {
    throw new Error('Method not implemented.');
  }
  public async updateEnumeration<T extends IFieldEnum>(enumId: number, updatedBy: string, enumeration: T): Promise<T[]> {
    throw new Error('Method not implemented.');
  }
  public async deleteEnumeration(enumId: number, updatedBy: string): Promise<void> {
    throw new Error('Method not implemented.');
  }
}